<div>
  <h3>Background Check Info</h3>
    <table class="table-striped table-hover custom-table">
        <tr>
            <th>Insurance Co</th>
            <th>Org</th>
            <th>Background Check Date</th>
            <th>Status</th>
        </tr>
        <!--<tr ng-repeat="backgroundViewModel in backgroundViewModels">
            <td>{{backgroundViewModel.InsuranceCompany}}</td>
            <td>{{backgroundViewModel.OrgName}}</td>
            <td>{{backgroundViewModel.BgApprovedDate}}</td>
            <td>{{backgroundViewModel.BackGroundStatus}}</td>
        </tr>-->
    </table>
</div>
